module.exports = __webpack_public_path__ + "static/media/e-clear_logo.3f9a658b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Logo/images/e-clear_logo.png
// module id = 702
// module chunks = 0